import { Application } from "@hotwired/stimulus";
import CountdownController from "./countdown_controller";
import RichTextController from "./rich_text_controller";
import TomSelectController from "./tom_select_controller";

const application = Application.start();
application.register("countdown", CountdownController);
application.register("rich-text", RichTextController);
application.register("tom-select", TomSelectController);

export { application };
